import { ArrowRight } from "lucide-react";
import { LiveBadge } from "./LiveBadge";
import { MiniCountdown } from "./MiniCountdown";
import {
  formatSessionShort,
  getNextSession,
} from "@/lib/selecao-sessions";

export const SelecaoCTAFinal = () => {
  const next = getNextSession();
  const short = formatSessionShort(next.date);

  return (
    <section className="bg-[#112711]">
      <div className="container-narrow py-20 sm:py-28 text-center">
        <LiveBadge className="bg-[#1F4A33] ring-[#4BD084]/40">{`Encontro exclusivo · ${short}`}</LiveBadge>

        <h2
          className="mt-6 text-2xl sm:text-3xl md:text-4xl font-bold text-white tracking-tight leading-[1.15] max-w-3xl mx-auto"
          style={{ letterSpacing: "-0.02em" }}
        >
          Entenda como você vai se diferenciar oferecendo o melhor produto de
          crédito estruturado do mercado para os seus clientes.
        </h2>

        <div className="mt-8 inline-flex items-center gap-2 text-sm text-[#D1F8E2]/70">
          <span>faltam</span>
          <MiniCountdown target={next.date} className="text-white" />
        </div>

        <div className="mt-10">
          <a
            href="#form"
            className="inline-flex items-center justify-center gap-2 rounded-full font-semibold text-sm h-12 sm:h-[52px] px-8 bg-white text-[#112711] hover:bg-[#D1F8E2] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-[#112711] focus-visible:ring-white"
          >
            Reservar minha vaga
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>

        <p className="mt-6 text-xs text-[#D1F8E2]/60">
          Programa exclusivo para profissionais certificados.
        </p>
      </div>
    </section>
  );
};
